<!-- <div class="base" *ngIf="informationObj['vin_number'].value || informationObj['vehicle_item_code']">
  <div class="base__info ml-auto">
    <span class="base__infoItem mb-2"><span class="font-weight-medium">VIN No.:</span> {{ informationObj['vin_number'].value }}</span>
    <span class="base__infoItem"><span class="font-weight-medium">Item Code:</span> {{ informationObj['vehicle_item_code'] }}</span>
  </div>
</div> -->

<section class="vam-gallery gallery py-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let item of allItems; index as i">
        <h4 class="fs fs__md mb-2">{{ item.gallery_name }}</h4>
        <div
          class="vam-gallery__item"
          [class.cursor-not-allowed]="
            (disableForm && role !== 'media_admin' && !editableRole.includes(role)) ||
            role === 'estimator' ||
            role === 'purchaser' ||
            role === 'purchasemanager'
          "
        >
          <div
            class="vam-gallery__img"
            (click)="openUpload(item.gallery_name, i)"
            [class.untouchable]="
              (disableForm && role !== 'media_admin' && !editableRole.includes(role)) ||
              role === 'estimator' ||
              role === 'purchaser' ||
              role === 'purchasemanager'
            "
          >
            <img src="{{ item.gallery_placeholder }}" [alt]="item.gallery_name" />
          </div>

          <div class="upload-actions" *ngIf="item.isImage">
            <button
              type="button"
              class="btn btn__utils bg-ashen"
              (click)="openViewer(item.gallery_placeholder)"
            >
              <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
        *ngIf="!disableForm || editableRole.includes(role)"
        [class.cursor-not-allowed]="
          !editableRole.includes(role) &&
          (role === 'estimator' || role === 'purchaser' || role === 'purchasemanager')
        "
      >
        <h4 class="fs fs__md more-title mb-2">More</h4>
        <a
          href="javascript:void(0)"
          class="vam-gallery__more"
          [class.untouchable]="
            !editableRole.includes(role) &&
            (role === 'estimator' || role === 'purchaser' || role === 'purchasemanager')
          "
          (click)="openFieldUploader()"
        >
          <span class="icon icon-4x">
            <img src="/assets/images/gallery/icons8-add.svg" />
          </span>
        </a>
      </div>
    </div>
  </div>
</section>

<loader [active]="loaded"></loader>

<!-- Modal -->
<div class="modal fade" bsModal #upload="bs-modal" (onHidden)="file = null">
  <div class="modal-dialog uploadModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Upload Image</h4>
        <button type="button" class="close" (click)="upload.hide()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <form class="condition__form credential" [formGroup]="uploader" (submit)="savePartImg()">
        <div class="modal-body optionsModal__body">
          <div class="vam_show_car_form_container">
            <div class="row mx-n2">
              <div class="col-12 px-2">
                <label for="" class="credential__label"> {{ title }} </label>

                <div class="form-group">
                  <label for="partImage" class="credential__file m-0">
                    <input
                      type="file"
                      name="partImage"
                      formControlName="partImage"
                      class="form-conrol d-none"
                      id="partImage"
                      (change)="getFile($event)"
                    />
                    <img
                      src="assets/images/car-image_icon.svg"
                      class="conditionFormFilePreview"
                      [hidden]="file"
                    />
                    <p class="fs fs__md" *ngIf="file">
                      {{ file.name }}
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer conditionModal__footer">
          <div class="conditionModal__footerInner">
            <div class="row w-100 mx-0">
              <div class="col-md-6 mx-auto px-0">
                <button type="submit" class="btn btn-primary w-100" [disabled]="uploading">
                  Done
                  <span class="spinner-grow spinner-grow-sm text-light ml-2" [hidden]="!uploading">
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
